import { useGetBusinessAccountDetailsQuery } from '@energy-stacks/fleet/feature-business-accounts-data';
import { useParams } from 'react-router-dom';

export const useBusinessAccountDetails = () => {
  const { businessAccountId } = useParams<{ businessAccountId: string }>();
  return useGetBusinessAccountDetailsQuery(businessAccountId || '', {
    skip: !businessAccountId,
  });
};
